import styled from 'styled-components';
import colors from 'constants/colors';

export const Content = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${colors.black1};
  height: calc(100vh - 50px);
  min-height: 610px;
  margin-top: 50px;

  @media only screen and (min-width: 767px) and (max-width: 1200px) {
    min-height: 460px;
    padding-bottom: 60px;
  }

  @media only screen and (min-width: 501px) and (max-width: 767px) {
    min-height: 570px;
    padding-bottom: 60px;
  }

  @media only screen and (min-width: 401px) and (max-width: 500px) {
    min-height: 490px;
    padding-bottom: 60px;
  }

  @media only screen and (min-width: 375px) and (max-width: 400px)  {
    min-height: 460px;
    padding-bottom: 60px;
  }

  @media only screen and (max-width: 374px) {
    min-height: 430px;
    padding-bottom: 60px;
  }

  & > div:first-child {
    min-width: 660px;
    max-width: 660px;

    @media only screen and (max-width: 767px) {
      width: 100%;
      min-width: 360px;
    }

    & div > h4 {
      color: ${colors.grey};
      margin-left: 12px;
    }
  }

  & > div:nth-child(2) {
    width: 100%;
    min-width: 240px;
  }

  & > div:nth-child(3) {
    width: 100%;
    min-width: 280px;
  }
`;

export const ContentColumn = styled.div`
  background-color: ${colors.black1};
  height: 100%;
  @media only screen and (max-width: 1200px) {
    ${({ desktop }) => (desktop ? `display: none;` : null)};
  }
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding: 15px;
  background-color: ${colors.black1};
  letter-spacing: 1px;
  height: 100%;
`;